<template>
  <div id="mobile-cart-button" class="bg-white">
    <div :loading="loading" class="d-flex justify-space-between align-center">
      <!-- No include-props: both this bar and the desktop price live in the
           DOM now, and the product must carry exactly one itemprop=offers —
           the desktop one owns it (VIP-12038) -->
      <Price
        id="mobile-price"
        class="d-flex flex-column justify-center py-2"
        :price="calculated.priceObject"
        :stock="stock"
        no-margin
      />
      <Cta
        v-if="!loading"
        class="pb-1"
        :pre-selected-qty="calculated.preSelectedQty"
        :product="product"
        :no-text="true"
        data-elbcontext="position:mobile"
      />
    </div>
  </div>
</template>

<script>
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const Cta = defineAsyncComponent(
  () => import('@/components/basic/molecules/Cta.vue')
)
const Price = defineAsyncComponent(
  () => import('@/components/basic/molecules/Price.vue')
)

export default {
  components: { Cta, Price },
  computed: {
    ...mapState(usePdpStore, {
      product: 'getApiProduct',
      calculated: 'getCalculated',
      stock: 'getFirstAvailableStock',
      loading: 'isUpdating'
    })
  }
}
</script>

<style scoped>
#mobile-cart-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  width: 100%;
  height: var(--pdp-mobile-cart-bar-height);
  background: rgb(var(--v-theme-white));
  -webkit-box-shadow: rgba(0, 0, 0, 0.25) 0 1px 3px 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.25);

  /** @see https://developer.mozilla.org/en-US/docs/Web/CSS/env */
  padding: 4px 16px max(env(safe-area-inset-bottom), 4px);
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    padding: 4px 48px;
  }
}
#mobile-price {
  height: var(--pdp-mobile-cart-bar-height);
}
:deep(.final-price) {
  font-weight: 500;
  font-size: var(--xl-font-size);
}
:deep(.reduced-price) {
  font-size: var(--s-font-size);
}
:deep(.currency) {
  font-size: var(--xl-font-size);
}
:deep(.price-per-unit) {
  font-size: var(--xs-font-size);
}
</style>
